import React, { useEffect, useState, useRef } from 'react';
import './Home.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaLanguage, FaGavel, FaSearch, FaChartLine, FaSync, FaCheckCircle, FaRobot, FaDatabase} from 'react-icons/fa';

const TypewriterText = ({ text, speed = 50 }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalRef = useRef(null);
  const cursorIntervalRef = useRef(null);

  useEffect(() => {
    // 清除之前的定时器
    if (intervalRef.current) clearInterval(intervalRef.current);
    if (cursorIntervalRef.current) clearInterval(cursorIntervalRef.current);

    // 重置状态
    setDisplayedText('');
    setCurrentIndex(0);

    // 开始打字效果
    intervalRef.current = setInterval(() => {
      setCurrentIndex(prevIndex => {
        if (prevIndex < text.length) {
          setDisplayedText(text.substring(0, prevIndex + 1));
          return prevIndex + 1;
        } else {
          // 打字完成后清除间隔定时器
          clearInterval(intervalRef.current);
          return prevIndex;
        }
      });
    }, speed);

    // 启动光标闪烁定时器
    cursorIntervalRef.current = setInterval(() => {
      // 光标闪烁通过CSS动画控制，这里只需确保它持续运行
    }, 500);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      if (cursorIntervalRef.current) clearInterval(cursorIntervalRef.current);
    };
  }, [text, speed]);

  return (
    <span>
      {displayedText}
      <span className="typewriter-cursor"></span>
    </span>
  );
};

const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('refresh')) {
      params.delete('refresh');
      navigate({ search: params.toString() }, { replace: true });
      window.location.reload();
    }
  }, [location, navigate]);

  // Progressive reveal on scroll using IntersectionObserver
  useEffect(() => {
    const elements = document.querySelectorAll('.reveal');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const features = [
    { 
      text: "Review bilingual translations", 
      icon: <FaLanguage /> 
    },
    { 
      text: "Check for typos, logical issues, grammar errors, etc.", 
      icon: <FaSearch /> 
    },
    { 
      text: "Validate against regulations and knowledge base", 
      icon: <FaGavel /> 
    },
    { 
      text: "Cross-check financial data", 
      icon: <FaDatabase /> 
    },
    { 
      text: "Compare with the industry reports", 
      icon: <FaChartLine /> 
    },
    { 
      text: "Cross-verify AI-generated content for accuracy", 
      icon: <FaRobot /> 
    },
    { 
      text: "Run any custom check you need", 
      icon: <FaCheckCircle /> 
    },
    // { 
    //   text: "Verify AI-generated content for complete accuracy", 
    //   icon: <FaRobot /> 
    // }
  ];

  const showcaseImages = [
    { src: 'https://picsum.photos/id/11/1000/600', alt: 'Bilingual documents review' },
    { src: 'https://picsum.photos/id/22/1000/600', alt: 'Knowledge base cross-check' },
    { src: 'https://picsum.photos/id/33/1000/600', alt: 'Sentence-by-sentence verification' },
    { src: 'https://picsum.photos/id/44/1000/600', alt: 'Peer document comparison' },
    { src: 'https://picsum.photos/id/55/1000/600', alt: 'Public content monitoring' },
    { src: 'https://picsum.photos/id/66/1000/600', alt: 'Customized reviews and AI auditing' }
  ];

  const [bgLoaded, setBgLoaded] = useState(false);
  const bgUrl = `${process.env.PUBLIC_URL}/20251108-221744.png`;

  useEffect(() => {
    const img = new Image();
    img.src = bgUrl;
    img.onload = () => setBgLoaded(true);
  }, [bgUrl]);

  return (
    <div className={`home-container ${bgLoaded ? 'bg-loaded' : ''}`} style={{ '--bg-url': `url(${bgUrl})` }}>
      <header className="hero">
        <h1 className="hero-title reveal">
          <span className="deep-text">deep</span>
          <span className="printer-text">printer</span>
        </h1>
        <p className="hero-subtitle reveal">
          <TypewriterText text="Your Expert in Multidimensional Document Review" speed={30} />
        </p>
        <div className="cta reveal">
          <a href="/feature-selection" className="btn">Get Started</a>
        </div>
      </header>

      <section className="features">
        {/* <h2 className="features-title reveal">Transform document review from challenge to advantage</h2> */}
        <ul className="features-list">
          {features.map((feature, idx) => (
            <li key={idx} className="feature-item reveal" style={{ '--i': idx + 1 }}>
              <div className="feature-icon">{feature.icon}</div>
              <div className="feature-text">{feature.text}</div>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default Home;